module.exports = __webpack_public_path__ + "static/media/vsb_logo.a5ce4673.png";